import React from 'react';

import { RequestPreviewProps } from '@/features/method-tester/types';
import { Text } from '@asphalt-react/typography';

const RequestPreview: React.FC<RequestPreviewProps> = ({ data, isVisible }) => {
  if (!isVisible) return null;

  return (
    <>
      <Text size="s">Request Preview:</Text>
      <div
        data-testid="individual-request-preview"
        className="bg-gray-100 p-3 rounded text-sm whitespace-pre-wrap"
      >
        {JSON.stringify(data, null, 2)}
      </div>
    </>
  );
};

export default RequestPreview;
